import { useState } from "react";
import type { Payment } from "../lib/adminTypes";
import { Field, Modal } from "./Modal";

const QUICK_REASONS = ["Amount doesn't match", "Screenshot unreadable", "Reference missing", "Duplicate payment"];

export function RejectModal({ payment, onClose, onConfirm }: { payment: Payment; onClose: () => void; onConfirm: (reason: string) => void }) {
  const [reason, setReason] = useState("");

  return (
    <Modal
      onClose={onClose}
      width={420}
      title="Reject payment?"
      sub={`${payment.ref} · The business sees this reason and can re-submit.`}
      footer={
        <>
          <button type="button" onClick={onClose} className="o-btn o-btn--grey" style={{ flex: 1 }}>
            Cancel
          </button>
          <button type="button" onClick={() => onConfirm(reason)} className="o-btn o-btn--coral" style={{ flex: 1 }}>
            Reject payment
          </button>
        </>
      }
    >
      <Field label="Quick reasons">
        <div className="o-chips" role="group" aria-label="Quick reasons" style={{ flexWrap: "wrap" }}>
          {QUICK_REASONS.map((r) => (
            <button type="button" key={r} aria-pressed={reason === r} onClick={() => setReason(r)}>
              {r}
            </button>
          ))}
        </div>
      </Field>
      <Field label="Reason for rejection">
        <textarea
          className="o-input o-input--area"
          aria-label="Reason for rejection"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          placeholder="e.g. Amount does not match, or screenshot unreadable…"
        />
      </Field>
    </Modal>
  );
}
